import { Box, Typography } from "@mui/material";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";

import FormComponentBlank from "../../../../../components/Backend/Admin/Posts/FormComponentBlank";
import { fetcheditPostsAsync } from "../../../../../redux/thunk/Posts";
import BackButton from "../../../../../components/Backend/BackButton";

const Edit = () => {
  const { editPost, editStatus } = useSelector((state) => state.posts);
  const postId = useParams();
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(fetcheditPostsAsync({ path: "posts-rl", id: postId.id }));
  }, [dispatch, postId.id]);

  return (
    <>
      <Box id="main" sx={{ width: "100%", p: 4 }}>
        <Box
          sx={{
            top: "1rem",
            position: "absolute",
            overflow: "visible",
            zIndex: 1500,
          }}
        >
          <Typography variant="h5">SWT, WE & Wemail</Typography>
        </Box>
        <Box sx={{ display: "flex", justifyContent: "space-between" }}>
          <Typography variant="h5" sx={{ my: 2 }}>
            Edit Post
          </Typography>
          <BackButton />
        </Box>
        {(editStatus === "loading" || editStatus === "failed") && (
          <Box>
            <Typography variant="h5">{editStatus}</Typography>
          </Box>
        )}

        {editStatus === "succeeded" && (
          <>
            <FormComponentBlank
              // category="rl"
              addPath="posts-writing"
              edit="edit"
              editTitle={editPost.title}
              editDifficulty={editPost.difficulty_level}
              pteType={editPost.pte_type}
              editContent={editPost.content}
              id={postId.id}
              category={editPost.category}
              editIsActive={editPost.isActive}
              editTranscript={editPost.transcript}
              editAnswerTemplate={editPost.answer_template}
              editEmailType={editPost?.email_type}
              editkeywordLength={editPost.keyword_length}
            ></FormComponentBlank>
          </>
        )}
      </Box>
    </>
  );
};

export default Edit;
